import firebase from "firebase/compat/app";
import { db, analytics, auth } from "../firebase";

// Reportes de errores del cliente (equivalente web a Crashlytics): van a la
// colección crashReports, que lee la pestaña "Crashes" de AdminPanel.js.
const MAX_REPORTS_PER_SESSION = 20;
let reportedCount = 0;

// Firestore sin conexión (celular sin señal, app que vuelve de segundo plano) o
// Analytics que arranca sin conexión (installations/app-offline): es una
// condición de red, no un bug, y no se puede corregir desde el código.
const isOfflineError = (error, message) =>
  error?.code === "unavailable" ||
  error?.code === "installations/app-offline" ||
  /client is offline/i.test(message);

export const reportError = (error, { fatal = false, context = {} } = {}) => {
  const message = (error && error.message) || String(error);
  const stack = (error && error.stack) || null;
  if (isOfflineError(error, message)) return;

  try {
    analytics.logEvent("exception", {
      description: message.slice(0, 150),
      fatal,
    });
  } catch (_) {
    // Analytics no disponible (ej. bloqueado por un ad-blocker); no bloquear el reporte.
  }

  if (reportedCount >= MAX_REPORTS_PER_SESSION) return;
  reportedCount += 1;

  const report = {
    message: message.slice(0, 2000),
    fatal,
    context,
    url: window.location.href.slice(0, 500),
    userAgent: navigator.userAgent.slice(0, 500),
    userId: auth.currentUser ? auth.currentUser.uid : null,
    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
  };
  // Las reglas validan stack como string: si no hay, no se manda (null las rompe).
  if (stack) report.stack = stack.slice(0, 4000);

  try {
    db.collection("crashReports").add(report).catch(() => {});
  } catch (_) {
    // Nunca dejar que el propio reporte de errores rompa la app.
  }
};

export const logNonFatal = (error, context = {}) => {
  reportError(error, { fatal: false, context });
};

// Errores de scripts de otros dominios (anuncios, extensiones) llegan sin
// detalle como "Script error." y no se pueden investigar: se ignoran.
const isOpaqueScriptError = (event) => !event.error && /^Script error\.?$/.test(event.message || "");

// Scripts que el navegador mete en la página y no son nuestros: el navegador
// interno de Facebook/Instagram (iabjs://), extensiones, etc. Solo cuentan los
// errores de archivos servidos por http(s); sin filename se reportan igual.
const isForeignScriptError = (event) => !!event.filename && !/^https?:/i.test(event.filename);

export const initCrashReporting = () => {
  window.addEventListener("error", (event) => {
    // Fallas al cargar <img>/<script> también disparan "error" (sin message).
    if (!(event instanceof ErrorEvent) || isOpaqueScriptError(event) || isForeignScriptError(event)) return;
    reportError(event.error || new Error(event.message), {
      fatal: true,
      context: { type: "window.onerror", filename: event.filename || null, lineno: event.lineno || null },
    });
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    const error = reason instanceof Error ? reason : new Error(String(reason));
    reportError(error, { fatal: false, context: { type: "unhandledrejection" } });
  });
};
